import { useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useMaintenance } from "../hooks/useMaintenance";

export function MaintenanceModal() {
  const { maintenance, message, checkMaintenance } = useMaintenance();

  useEffect(() => {
    checkMaintenance();
  }, [checkMaintenance]);

  return (
    <Modal
      show={maintenance === true}
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header>
        <Modal.Title>Mohon Maaf</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{message || "Sistem sedang dalam pemeliharaan."}</p>
      </Modal.Body>
    </Modal>
  );
}
